<template>
  <div class="col-12 d-flex flex-column mb-3">
    <div style="flex: 1;margin-left: 45px;">
      <div class="row">
        <div class="col-12">
          <section-title :title="$t('apps.inventory.label.serialnumber')" />
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div
        v-for="(item, index) in value"
        :key="index"
        class="col-12"
      >
        <div class="form-row">
          <div
            ref="ser-wrapper"
            :class="[{'col-md-9': !disabled, 'col-md-8': disabled}, serClassName]"
            class="ser-wrapper mb-2"
          >
            <div class="d-flex">
              <div style="width: 45px;"/>
              <div
                class="form-row"
                style="flex: 1;">
                <div class="col-12">
                  <div class="form-row form-row-items">
                    <div class="col-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('apps.inventory.message.bin') }}</span>
                        </div>
                        <BaseDropdown
                          v-model="item.binId"
                          :options="binOptions"
                          :disabled="disabled" />
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('apps.inventory.message.serialnumber') }}</span>
                        </div>
                        <BaseInput
                          v-model="item.serialNumber"
                          :disabled="disabled" />
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('apps.inventory.message.dateproduct') }}</span>
                        </div>
                        <BaseInputDatePicker
                          v-model="item.dateProduct"
                          :disabled="disabled" />
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('apps.inventory.message.dateexpire') }}</span>
                        </div>
                        <BaseInputDatePicker
                          v-model="item.dateExpire"
                          :disabled="disabled" />
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('apps.inventory.message.cost') }}</span>
                        </div>
                        <BaseInputNumber
                          v-model="item.cost"
                          :disabled="disabled" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="index < value.length - 1"
                    class="row">
                    <div class="col-12">
                      <hr style="margin: 15px 0 5px 0;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    warehouses: Array,
    selectedWhId: String,
    disabled: Boolean,
  },

  data() {
    return {
      serClassName: '',
    }
  },

  computed: {
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    binOptions () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.selectedWhId) {
          const bins = cur.bin_locations.map((bin) => {
            return {
              text: bin.code,
              value: bin._id,
            }
          })
          if (bins.length) {
            acc.push(...bins)
          }
        }
        return acc
      }, [])
      return [this.defaultOption, ...items]
    },
  },

  mounted() {
    this.setLotUI()

    window.addEventListener('resize', this.handleWindowResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize, false)
  },

  methods: {
    setLotUI() {
      if (this.$refs['ser-wrapper'] && this.$refs['ser-wrapper'].length > 0) {
        if (this.$refs['ser-wrapper'][0].clientWidth < 800) {
          this.serClassName = 'responsive'
        } else {
          this.serClassName = ''
        }
      }
    },
    handleWindowResize() {
      this.setLotUI()
    },
  },
}
</script>

<style scoped>
.ser-wrapper.responsive {
  height: auto;
}

.ser-wrapper.responsive .form-row-items > div {
  width: 100%;
  max-width: 100%;
  flex: none;
  margin-bottom: .5rem;
}

.ser-wrapper.responsive .form-row-items > div:last-of-type {
  margin-bottom: 0;
}

.ser-wrapper.responsive .form-row-items .input-group-text {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseGRPutAwaySerial.vue